interface Deletable {
  isDeleted?: boolean | null;
}

export function filterNotDeleted<TEntity extends Deletable>(
  entities: TEntity[] | undefined
): TEntity[] | undefined {
  return entities?.filter((entity) => entity.isDeleted !== true);
}
